<template>
  <div class="logo text-center">
    <img class="logo-image" :src="`${publicPath}logo.svg`" />
    <div class="logo-name text-white mt-4">
      {{ serverName }}
    </div>
  </div>
</template>

<script>
import http from '@/modules/http.js'
import('@/styles/components/start-logo.less')

export default {
  name: 'StartLogo',
  data: () => ({
    publicPath: process.env.BASE_URL
  }),
  mounted() {
    if (this.$store.getters.HAS_SERVER_NAME) {
      return
    }
    this.loadSettings()
  },
  computed: {
    serverName() {
      return this.$store.getters.SERVER_NAME || ''
    }
  },
  methods: {
    loadSettings() {
      http
        .get('/settings')
        .then(response => response.data.server_name)
        .then(name => {
          this.$store.dispatch('UPDATE_SERVER_NAME', name)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
